import type { ThemeMetadata } from './types';

export const premium: ThemeMetadata = {
  name: 'premium',
  label: 'Premium',
  vibe: 'Modernité éditoriale, autorité visuelle. Pour les jeunes patrons qui transforment.',
  preview: {
    background: '#FAFAFA',
    surface: '#FFFFFF',
    accent: '#0F1419',
  },
};
